"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var SEO = function (_a) {
    var _b = _a.description, description = _b === void 0 ? "" : _b, _c = _a.keywords, keywords = _c === void 0 ? "" : _c, _d = _a.image, image = _d === void 0 ? "" : _d, _e = _a.title, title = _e === void 0 ? "" : _e, _f = _a.type, type = _f === void 0 ? "website" : _f, _g = _a.url, url = _g === void 0 ? "" : _g, icons = _a.icons, websiteName = _a.websiteName;
    var fullTitle = "".concat(title ? "".concat(title, " - ") : "").concat(websiteName);
    return (react_1.default.createElement(react_helmet_1.Helmet, { defer: false },
        react_1.default.createElement("html", { lang: "fr" }),
        react_1.default.createElement("title", null, fullTitle),
        react_1.default.createElement("meta", { property: "og:title", content: fullTitle }),
        react_1.default.createElement("meta", { name: "twitter:title", content: fullTitle }),
        react_1.default.createElement("meta", { name: "description", content: description }),
        react_1.default.createElement("meta", { property: "og:description", content: description }),
        react_1.default.createElement("meta", { name: "twitter:description", content: description }),
        react_1.default.createElement("meta", { name: "keywords", content: keywords }),
        react_1.default.createElement("meta", { name: "image", content: image }),
        react_1.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
        react_1.default.createElement("meta", { name: "twitter:image", content: image }),
        react_1.default.createElement("meta", { property: "og:image", content: image }),
        react_1.default.createElement("meta", { property: "og:image", content: image }),
        react_1.default.createElement("meta", { property: "og:url", content: "".concat(url ? "/".concat(url) : "") }),
        react_1.default.createElement("meta", { property: "og:type", content: type }), icons === null || icons === void 0 ? void 0 :
        icons.map(function (icon, index) {
            return icon.href ? (react_1.default.createElement("link", { key: index, rel: icon.rel, type: "image/png", href: icon.href, sizes: "".concat(icon.sizes[0], "x").concat(icon.sizes[1]) })) : null;
        })));
};
exports.default = (0, react_1.memo)(SEO);
